import script from "./amountCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./amountCard.vue?vue&type=script&setup=true&lang=ts"

import "./amountCard.vue?vue&type=style&index=0&id=30bae138&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30bae138"]])

export default __exports__